/**
 * Browser-safe exports for @cogo/validator.
 *
 * This entry point excludes node:fs-dependent modules (validator, loaders, CLI)
 * so it can be imported in Vite/browser environments without errors.
 */

export type {
  ValidationReport,
  ValidationIssue,
  StageResult,
  ValidationSummary,
  BlockReport,
  ValidatorOptions,
  BlockBundle,
  AppBundle,
  Severity,
  Grade,
  TargetType,
  LlmValidationIssue,
  LlmValidateRequest,
  LlmValidateResponse,
  LlmUxContext,
  FixSummary,
} from "./types"
export { computeScore, computeGrade } from "./scoring"
export {
  generatePromptFeedbackFromBundle,
  getPromptFeedback,
  bundleToBlockData,
  getFeaturePatternRules,
} from "./feedback-bridge"
export {
  extractInteractiveIntents,
  INTENT_MAP,
} from "./fixers/interactive-intent-extractor"
export type { InteractiveElement } from "./fixers/interactive-intent-extractor"

// Phase 438 Plan 01 — pure jsonb-aware validator API (VAL-01) joins the
// browser-safe export surface. Pre-existing browser.ts curated set excluded
// node:fs-dependent modules; validateActionFlow has zero fs imports per
// CONTEXT D-A2 + D-C2 (verified by grep at Plan 01 entry; Plan 02 ESLint
// rule will enforce going forward).
export { validateActionFlow } from "./jsonb-api"
export type { ValidateActionFlowInput, PureValidatorOptions } from "./jsonb-api"
export type { TripleJson } from "./jsonb-api/codec"
export { runAiJudgeStage } from "./stages/stage-ai-judge"
export { analyzeStateTransitions } from "./features/state-transition-analyzer"
export type {
  StateMutationOperation,
  StateRef,
  StateScope,
  StateTransition,
  StateTransitionAnalyzerOptions,
  StateTransitionIssue,
  StateTransitionReport,
  StateWrite,
} from "./features/state-transition-analyzer"
export { proveStateTransitions } from "./features/state-transition-proof"
export type {
  StateTransitionProofReport,
  TransitionProof,
  TransitionProofStatus,
  TransitionTraceInput,
  TransitionTraceStateDiff,
} from "./features/state-transition-proof"
